import { SkillGrid } from './skill-grid';

export function ExperienceSection() {
  return (
    <div className="row-span-4 flex flex-col">
      <SkillGrid />
    </div>
  );
}